import { useEffect, useState } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { getFirebaseAuth } from '../config/firebase';
import { consumePortalHandoffIfPresent } from '../services/portalHandoff';

export function useAuthUser(): {
  user: User | null;
  loading: boolean;
  handoffError: string | null;
} {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [handoffError, setHandoffError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    // Restore the IndexedDB session immediately. Native `?handoff=` runs in
    // parallel so a marketing Sign in click is not blocked on Functions.
    const unsub = onAuthStateChanged(getFirebaseAuth(), (u) => {
      if (cancelled) return;
      setUser(u);
      setLoading(false);
    });

    void consumePortalHandoffIfPresent()
      .then((handoff) => {
        if (cancelled) return;
        if (handoff.error) setHandoffError(handoff.error);
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return { user, loading, handoffError };
}
